import React, { useRef } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import BookmarkCategoryAddModal from '../components/BookmarkCategoryAddModal'
import { rememberCreated } from '../utils/platelistCreateReturn'

/**
 * 플레이트리스트 추가/수정 페이지.
 * 기존 바텀시트(BookmarkCategoryAddModal)를 asPage 모드로 재사용한다.
 * - /platelist/new       → 추가
 * - /platelist/:id/edit  → 수정
 * 완료/취소 시 뒤로가기하면 이전 페이지가 재마운트되며 목록을 다시 로드한다
 * (그래서 별도 결과 전달 콜백이 필요 없음).
 */
const PlateListForm: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { categoryId } = useParams<{ categoryId?: string }>()
  // 편집 진입 시 목록에서 넘겨준 커버 URL(있으면 API 대기 없이 즉시 표시)
  const initialThumbnail =
    (location.state as { thumbnail?: string | null } | null)?.thumbnail ?? null

  // 성공 경로에선 onClose 후 onSuccess가 이어 호출되므로 중복 뒤로가기 방지
  const navigatedRef = useRef(false)
  const goBack = () => {
    if (navigatedRef.current) return
    navigatedRef.current = true
    navigate(-1)
  }

  return (
    <BookmarkCategoryAddModal
      asPage
      isOpen
      categoryId={categoryId}
      initialThumbnail={initialThumbnail}
      onClose={goBack}
      onSuccess={(category) => {
        /*
         * 뒤로가기는 onClose에서 처리, 목록 갱신은 이전 페이지 재마운트가 담당.
         *
         * 다만 담기 시트에서 "추가"로 들어온 경우에는, 돌아갔을 때
         * 방금 만든 것이 체크돼 있어야 한다. 뒤로가기에는 값을 실을 수 없어서
         * 따로 적어둔다(utils/platelistCreateReturn).
         */
        if (!categoryId) rememberCreated(String(category.id))
      }}
    />
  )
}

export default PlateListForm
